import { io } from 'socket.io-client'

import { getAccessToken } from '@/features/auth/utils/tokenStorage'
import { env } from '@/shared/config/env'

const getSocketUrl = () =>
  import.meta.env.VITE_SOCKET_URL?.trim() ||
  env.apiBaseUrl?.replace(/\/api\/v1\/?$/, '') ||
  'http://localhost:8000'

class SocketService {
  socket = null

  connect(options = {}) {
    const token = getAccessToken()

    if (!token) {
      console.error('❌ Socket connect skipped: no access token')
      return null
    }

    // Reuse existing instance but always refresh auth before (re)connect
    if (this.socket) {
      this.socket.auth = { token }

      if (!this.socket.connected) {
        console.log('🟢 Reconnecting socket with fresh token...')
        this.socket.connect()
      }

      return this.socket
    }

    console.log('🟢 Creating socket instance...')

    this.socket = io(getSocketUrl(), {
      withCredentials: true,
      autoConnect: false,
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      // Fetch token on every handshake (connect + reconnect)
      auth: (cb) => {
        cb({ token: getAccessToken() || '' })
      },
      ...options,
    })

    this.socket.on('connect', () => {
      console.log('🟢 Socket Connected:', this.socket.id)
    })

    this.socket.on('disconnect', (reason) => {
      console.log('🔴 Socket Disconnected:', reason)
    })

    this.socket.on('connect_error', (error) => {
      console.error('❌ Socket Connection Error:', error.message)
    })

    this.socket.auth = { token }
    this.socket.connect()

    return this.socket
  }

  getSocket() {
    return this.socket
  }

  disconnect() {
    if (!this.socket) return

    console.log('🔴 Disconnecting socket...')

    this.socket.removeAllListeners()
    this.socket.disconnect()
    this.socket = null
  }

  isConnected() {
    return Boolean(this.socket?.connected)
  }
}

const socketService = new SocketService()

export default socketService
